import { GridCustomCellProps } from "@progress/kendo-react-grid";

const CalleeCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  if (!props.dataItem.CalleeName) {
    return <td {...props.tdProps}>{props.dataItem.CalleeNumber}</td>;
  }

  return <td {...props.tdProps} title={props.dataItem.CalleeNumber}>{props.dataItem.CalleeName}</td>;
}

export default CalleeCell;

